<div class="assets-approval-container">
  <div class="modal-header">
    <div class="d-flex flex-column flex-lg-row w-100 align-items-lg-center justify-content-lg-between header-row">
      <h2 class="text-uppercase modal-title">{{ 'edit_vote_approval' | translate }}</h2>
      <div class="ms-lg-auto d-flex flex-column flex-sm-row modal-buttons">
        <button class="btn cancel-btn" (click)="cancel()" [disabled]="isLoading">{{ 'cancel' | translate }}</button>
        <button class="btn save-btn" (click)="save()" [disabled]="isLoading || versionData?.files?.length == 0">{{
          'save' | translate
        }}</button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mb-3 selector-row">
      <div class="d-flex flex-column">
        <h3 class="mb-0 option-title">{{ activeOption.title }}</h3>
        <div class="desc">{{ 'versioning_batchApproval_checkAssetsLabel' | translate }}</div>
      </div>
      <div class="d-flex flex-wrap align-items-center justify-content-between selector-container">
        <div class="action-selector" ngbDropdown container="body" dropdownClass="assets-approval-menu">
          <button type="button" class="btn d-flex align-items-center text-capitalize selected-action" ngbDropdownToggle>
            <ng-container [ngSwitch]="selectedAction">
              <approval-yes-icon *ngSwitchCase="'YES'"></approval-yes-icon>
              <approval-no-icon *ngSwitchCase="'NO'"></approval-no-icon>
              <approval-na-icon *ngSwitchDefault></approval-na-icon>
            </ng-container>
            <span class="text-uppercase d-inline-block mx-2">{{ selectedLabel | translate }}</span>
          </button>
          <div ngbDropdownMenu class="action-menu">
            <button
              ngbDropdownItem
              class="d-flex align-items-center"
              *ngFor="let action of voteOptions"
              (click)="changeAction(action.value)">
              <ng-container [ngSwitch]="action.value">
                <approval-yes-icon *ngSwitchCase="'YES'"></approval-yes-icon>
                <approval-no-icon *ngSwitchCase="'NO'"></approval-no-icon>
                <approval-na-icon *ngSwitchDefault></approval-na-icon>
              </ng-container>
              <span class="text-uppercase d-inline-block ms-2">
                {{ action.text | translate }}
              </span>
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center ms-sm-auto ms-lg-9 select-wrapper">
          <span class="d-inline-block">{{ 'selectAll' | translate }}</span>
          <mtm-checkbox
            class="ms-2"
            [checked]="isSelectAll"
            [indeterminate]="isPartialSelection()"
            (checkedChange)="onSelectAllChange($event)" />
        </div>
      </div>
    </div>
    <div class="files-container">
      <div
        class="d-flex align-items-center justify-content-center flex-column options-loading-container"
        *ngIf="isLoading && versionData.files?.length == 0">
        <span class="mb-2">{{ 'loading' | translate }}</span>
        <mtm-loading-spinner [size]="18"></mtm-loading-spinner>
      </div>
      <div class="files" *ngIf="!isLoading || versionData?.files?.length > 0">
        <div class="file" *ngFor="let file of versionData?.files">
          <div class="d-flex align-items-center outer">
            <div class="thumb">
              <div class="asset-item" [assetPreviewThumbnailPosition]="'horizontal'" [assetPreviewDirective]="file">
              </div>
              <mtm-checkbox
                class="thumb__checkbox"
                [(ngModel)]="selectedRecord[file.id]"
                (ngModelChange)="adjustCheckState()" />
              <div class="d-none d-lg-flex align-items-center voters-row">
                <div class="d-flex align-items-center" *ngIf="approvalVotes[file.id]?.length > 0">
                  <div
                    class="d-flex justify-content-center align-items-center icon-wrapper accept-wrapper"
                    [ngbTooltip]="approvalVotes[file.id]?.length > 0 ? proBatchTooltip : null"
                    tooltipClass="voters-tooltip">
                    <img src="/assets/svg/subsection/thumb-up-white.svg" alt="Thumb Up" width="14" height="14" />
                  </div>
                  <asset-voters class="d-none d-lg-block voters" [voters]="approvalVotes[file.id]"></asset-voters>
                  <ng-template #proBatchTooltip>
                    <asset-voters [voters]="approvalVotes[file.id]" [viewMode]="'tooltip'"></asset-voters>
                  </ng-template>
                </div>
                <div class="d-flex align-items-center" *ngIf="rejectionVotes[file.id]?.length > 0">
                  <div
                    class="d-flex justify-content-center align-items-center icon-wrapper reject-wrapper"
                    [ngbTooltip]="rejectionVotes[file.id]?.length > 0 ? oppBatchTooltip : null"
                    tooltipClass="voters-tooltip">
                    <img src="/assets/svg/subsection/thumb-down-white.svg" alt="Thumb Down" width="14" height="14" />
                  </div>
                  <asset-voters class="d-none d-lg-block voters" [voters]="rejectionVotes[file.id]"></asset-voters>
                  <ng-template #oppBatchTooltip>
                    <asset-voters [voters]="rejectionVotes[file.id]" [viewMode]="'tooltip'"></asset-voters>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
